
import { cartPageContainerStyles } from "@insite/content-library/Widgets/Cart/CartPageContainer";
import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

export const cartPageContainerStylesExtension = cartPageContainerStyles.container = mergeToNew(cartPageContainerStyles.container, {
    css: css`
        @media print {
           display: none !important;
        }        
    `,
});